<template>
  <div>
    <validation-observer ref="observer">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <div class="text-sm-right mb-4 mt-4 group">
        <div v-if="checkAuthorization('kpi_update')" class="group-btn">
          <v-btn
            class="success mx-0 mr-2"
            small
            @click="saveKpiDetailTls"
          >
            <v-icon class="mr-1" size="18">mdi-content-save</v-icon> Lưu lại
          </v-btn>
          <v-btn
            class="default mx-0"
            small
            @click="cancelSave"
          >
            <v-icon size="18" class="mr-1">mdi-cancel</v-icon> Huỷ thay đổi
          </v-btn>
        </div>
      </div>
      <v-simple-table class="table-layout border-table table-custom">
        <template v-slot:default>
          <thead>
            <tr>
              <th
                :rowspan="2"
              >
                STT
              </th>
              <th
                :rowspan="2"
              >
                Tên nhân viên
              </th>
              <th
                :rowspan="2"
              >
                Nhóm
              </th>
              <th
                :colspan="9"
              >
                Doanh số
              </th>
            </tr>
            <tr>
              <th>
                Chỉ tiêu doanh thu
              </th>
              <th>
                Doanh thu thực tế
              </th>
              <th>
                Độ quan trọng DT (%)
              </th>
              <th>
                Chỉ tiêu tỷ lệ chốt (%)
              </th>
              <th>
                Tỷ lệ chốt thực tế (%)
              </th>
              <th>
                Độ quan trọng TLC (%)
              </th>
              <th>
                KPI (%)
              </th>
              <th>
                Không thiết lập KPI?
              </th>
              <th>
                Ghi chú
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(user, index) in users">
              <tr :key="user.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ user.fullName }}
                </td>
                <td>
                  {{ _.get(user, 'department.name', '') }}
                </td>
                <td :class="getClass(user, 'targetRevenue')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{ required: user.noNeedSetKPI ? false : true, min_value: 0, max_value: 999999999999999, max: 15 }"
                    name="Chỉ tiêu doanh thu"
                    :vid="`targetRevenue_${user.id}`"
                  >
                    <v-currency-field
                      :error-messages="errors"
                      v-model="user.targetRevenue"
                      :readonly="passed"
                    />
                  </validation-provider>
                </td>
                <td>
                  {{ formatPrice(_.get(user, 'turnOverSuccess', 0)) }}
                </td>
                <td :class="getClass(user, 'importantLevel')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{required: user.noNeedSetKPI ? false : true, regex: /^[0-9]*$/, min_value: 0, max_value: 100  }"
                    name="Độ quan trọng DT"
                    :vid="`importantLevel_${user.id}`"
                  >
                    <v-text-field
                      v-model="user.importantLevel"
                      :error-messages="errors"
                      color="primary"
                      :readonly="passed"
                      @change="calculateRate('importantLevel', user.importantLevel, index)"
                    />
                  </validation-provider>
                </td>
                <td :class="getClass(user, 'targetRate')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{required: user.noNeedSetKPI ? false : true, regex: /^[0-9]*$/, min_value: 0, max_value: 100 }"
                    name="Chỉ tiêu tỷ lệ chốt"
                    :vid="`targetRate_${user.id}`"
                  >
                    <v-text-field
                      v-model="user.targetRate"
                      :error-messages="errors"
                      color="primary"
                      :readonly="passed"
                    />
                  </validation-provider>
                </td>
                <td>
                  {{ _.get(user, 'latchRatioSuccess', '') }}
                </td>
                <td :class="getClass(user, 'importantRateLevel')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{required: user.noNeedSetKPI ? false : true, regex: /^[0-9]*$/, min_value: 0, max_value: 100, regex: /^[0-9]*$/ }"
                    name="Độ quan trọng TLC"
                    :vid="`importantRateLevel_${user.id}`"
                  >
                    <v-text-field
                      v-model="user.importantRateLevel"
                      :error-messages="errors"
                      color="primary"
                      :readonly="passed"
                      @change="calculateRate('importantRateLevel', user.importantRateLevel, index)"
                    />
                  </validation-provider>
                </td>
                <td>
                  {{ _.get(user, 'kpi', 0) + '%' }}
                </td>
                <td>
                  <v-checkbox
                    v-model="user.noNeedSetKPI"
                  />
                </td>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{required: user.noNeedSetKPI ? false : false }"
                    name="Ghi chú"
                    :vid="`node_${user.id}`"
                  >
                    <v-text-field
                      v-model="user.note"
                      :error-messages="errors"
                      color="primary"
                    />
                  </validation-provider>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </validation-observer>
  </div>
</template>
<script>
  import { formatPrice } from '@/helpers/utils'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import { formatDate } from '../../../helpers/utils'
  const KpiRepository = RepositoryFactory.get('kpi')
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      users: {
        type: Array,
        default: () => {},
      },
      oldUsers: {
        type: Array,
        default: () => {},
      },
      activeTab: {
        type: Number,
        default: null,
      },
      passed: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        errorMessage: '',
        currencyClass: 'currency',
      }
    },
    created () {
    },
    methods: {
      async cancelSave () {
        this.$swal({
          title: 'Huỷ thay đổi',
          text: 'Bạn có thực sự muốn huỷ thay đổi?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            this.$set(this, 'users', _.cloneDeep(this.oldUsers))
          }
        })
      },
      async saveKpiDetailTls () {
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          const kpiDetails = this.users.map(user => ({
            userId: user.id,
            targetRevenue: user.noNeedSetKPI ? null : user.targetRevenue,
            importantLevel: user.noNeedSetKPI ? null : user.importantLevel,
            targetRate: user.noNeedSetKPI ? null : user.targetRate,
            importantRateLevel: user.noNeedSetKPI ? null : user.importantRateLevel,
            note: user.note,
            noNeedSetKPI: user.noNeedSetKPI,
          }))
          this.$swal({
            title: 'Lưu lại',
            text: 'Bạn có thực sự muốn lưu thay đổi?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Đồng ý',
            cancelButtonText: 'Hủy bỏ',
          }).then(async (result) => {
            if (result.value) {
              // const loader = this.$loading.show()
              this.appLoadingData(true)
              const kpiId = this.$route.params.id
              console.log('kpiId..',kpiId)
              const response = await KpiRepository.saveKpiDetail(kpiId, kpiDetails)
              // loader.hide()
              this.appLoadingData(false)
              if (response.success) {
                this.$swal({
                  title: 'Lưu thành công!',
                  confirmButtonText: 'Đồng ý',
                },
                ).then(() => {
                  console.log('activeTab', this.activeTab)
                  // window.location.href = `/users/kpi/detail/${this.$route.params.id}?activeTab=${this.activeTab}`
                  this.$router.push({
                    name: 'KPIDetail',
                    params: { id : kpiId || 0 },
                    query: {activeTab: this.activeTab}
                  })
                })
              } else {
                this.$swal({
                  type: 'error',
                  title: 'Lỗi!',
                  text: _.get(response, 'message', ''),
                })
              }
            }
          })
        }
      },
      getClass(user, fieldName) {
        const oldValue = _.get(this.oldUsers.find(u => u.id === user.id), fieldName, null);
        if(oldValue && _.get(user, fieldName, null) && parseInt(oldValue, 10) !== parseInt(_.get(user, fieldName, null), 10)) return 'text-updating'
        else if(!oldValue && _.get(user, fieldName, null)) return 'text-updating'
        return ''
      },
      calculateRate(e, value, index) {
        if (value > 100) return
        if(e == 'importantLevel') {
          this.users[index].importantRateLevel = 100 - value
        } else {
          this.users[index].importantLevel = 100 - value
        }
      }
    },
  }
</script>
<style scoped lang="scss">
.table-custom {
  .text-updating{
    background-color: #ECFDF0;
  }
}
</style>
